import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import jsKit from './jsKit';
import { swipers } from './swipers';
import { appendOAuthComponents } from './kitmanAuth';
import { createGA4Event } from './kitmanGa4';

const kitman = (() => {
  const defaults = {
    debugMode: false,
    step2_products_amount: '-',
  };

  const debug = (message, ...args) => {
    if (defaults.debugMode) {
      console.log(message, ...args);
    }
  };

  const setButtonLoading = (button, isLoading = true) => {
    jsKit.setLoading(button, isLoading, { disabled: true });
  };

  const getEventDataParts = (e, dataItem, separator = ', ') => jsKit.getDataParts(e.target, dataItem, separator);

  const updateSlotContent = (data, content = '') => {
    if (data.slot_id) {
      jsKit.setHtml(`#slot_content_${data.view_id}_${data.slot_id}`, content);
      jsKit.setHtml(`#slot_content_enlarge_${data.view_id}_${data.slot_id}`, content);
    }

    if (data.slot_ghost_id) {
      jsKit.setHtml(`#slot_ghost_content_${data.slot_ghost_id}`, content);
    }
  };

  const renderSlotContent = (data, ghostContentKey = 'slot_ghost_content') => {
    updateSlotContent(data, data.slot_content || '');

    if (data.slot_ghost_id && data[ghostContentKey]) {
      jsKit.setHtml(`#slot_ghost_content_${data.slot_ghost_id}`, data[ghostContentKey]);
    }
  };

  const updateSlotRadioState = (target, form = document, suffix = '') => {
    if (!target || target.type !== 'radio') return;

    const inactiveClass = 'border-opacity-50';
    const colorNames = [
      'slot_form[color_id]',
      'slot_form[embroidery_color_1]',
      'slot_form[embroidery_color_2]',
    ];

    if (colorNames.includes(target.name)) {
      form.querySelectorAll(`[name="${target.name}"]`)
        .forEach((sibling) => sibling.nextElementSibling.classList.add(inactiveClass));
      target.nextElementSibling.classList.remove(inactiveClass);
    }

    if (target.name !== 'slot_form[small_letters]') return;

    const input = form.querySelector('[name="slot_form[content]"]');
    const normalId = suffix ? `slot-normal-letters-${suffix}` : 'slot-normal-letters';
    const capitalId = suffix ? `slot-capital-letters-${suffix}` : 'slot-capital-letters';

    if (target.id === normalId) {
      input.classList.remove('text-uppercase');
    }
    if (target.id === capitalId) {
      input.classList.add('text-uppercase');
    }
  };

  const saveFiltersScrollTop = () => {
    const panelConfiguration = document.querySelector('#panel_filters');
    const scrollPanel = panelConfiguration.querySelector('.overflow-x-auto');
    panelConfiguration.dataset.jsScrollTop = scrollPanel.scrollTop.toString();
  };

  const restoreFiltersScrollTop = (panelConfiguration) => {
    if (!panelConfiguration.dataset.jsScrollTop) return;

    const scrollPanel = panelConfiguration.querySelector('.overflow-x-auto');
    setTimeout(() => scrollPanel.scrollTop = parseInt(panelConfiguration.dataset.jsScrollTop, 10), 10);
  };

  const loadSlotForm = async ({ view, slot, dataAttr, urlPrefix }) => {
    if (!view || !slot) return;

    let mySlot = slot;
    const activeClasses = ['bg-opacity-25', 'border-2'];
    const unActiveClasses = ['bg-opacity-10', 'border-opacity-50'];
    const slots = document.querySelectorAll(`[data-${jsKit.toKebabCase(dataAttr)}]`);
    const panelConfiguration = document.querySelector('#panel_filters');
    panelConfiguration.classList.add('loading');
    if (jsKit.rwdMedia.xs || jsKit.rwdMedia.sm || jsKit.rwdMedia.md) {
      kitman.toggleSideMenu('#panel_filters', true);
    }

    if ([...slots].length) {
      const originSlot = document.querySelector('.product-photo')
        .querySelector(`[data-${jsKit.toKebabCase(dataAttr)}]`)
        .getAttribute(`data-${jsKit.toKebabCase(dataAttr)}`)
        .split(', ')[1];

      if (mySlot.toString() === '1') {
        mySlot = originSlot;
      }

      slots.forEach((item) => {
        activeClasses.forEach((activeClass) => item.classList.remove(activeClass));
        unActiveClasses.forEach((unActiveClass) => item.classList.add(unActiveClass));
      });
    }

    const activeSlot = document.querySelector(`#slot_content_${view}_${mySlot}`);
    if (activeSlot) {
      activeClasses.forEach((activeClass) => activeSlot.parentElement.classList.add(activeClass));
      unActiveClasses.forEach((unActiveClass) => activeSlot.parentElement.classList.remove(unActiveClass));
    }

    const data = await jsKit.requestUrl(`${urlPrefix}/${view}/${mySlot}`, 'text');
    if (typeof data === 'undefined') return;

    panelConfiguration.classList.remove('loading');
    jsKit.setHtml(panelConfiguration, data);
    restoreFiltersScrollTop(panelConfiguration);
    jsKit.autofocus(panelConfiguration);
    jsKit.initTooltipsIn(panelConfiguration);
  };

  const setFiltersLoading = (isLoading = true) => {
    jsKit.setLoading(document.querySelector('#panel_filters'), isLoading);
  };

  const refreshOutfitView = async (productViewId, options = {}) => {
    const {
      reloadOutfits = false,
      refreshThumbnail = false,
      refreshSummary = false,
      refreshHiddenPictures = false,
    } = options;

    await kitman.loadGhostViewDefault(1);
    await kitman.loadKitbuilderProductItem();
    await kitman.loadKitbuilderSlotItem(productViewId, 1);

    if (reloadOutfits) {
      await kitman.loadOutfitsViewDefault();
    }

    await kitman.loadGhostClickables();

    if (refreshThumbnail) {
      await kitman.loadOutfitThumbnail();
    }

    if (refreshSummary) {
      await kitman.loadSummaryPanel();
    }

    if (refreshHiddenPictures) {
      await kitman.refreshGhostHiddenPicturesOutfit();
    }
  };

  return {

    pushToDataLayer: (data) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(data);
    },

    GA4Event: createGA4Event((data) => kitman.pushToDataLayer(data)),

    kitmanSetDelete: () => {
      if (defaults.debugMode) {
        console.log('kitmanSetDelete()');
      }

      document.cookie = 'kitman_set=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },

    // POK
    showMovie: (e) => {
      const { target } = e;
      const html = document.querySelector(target.dataset.jsShowMovie).innerHTML;
      const bgVideo = document.querySelector('.background-video video');

      function closeVideo() {
        const modalVideo = document.querySelector('#popup_container video');
        bgVideo.play();
        modalVideo.pause();
        jsKit.emptyModal();
      }
      function openVideo() {
        const modalVideo = document.querySelector('#popup_container video');
        bgVideo.pause();
        modalVideo.play();
      }

      jsKit.openModal(html, { size: 'modal-xl', shownCB: openVideo, hiddenCB: closeVideo });
    },

    showOfferInfo: (e) => {
      const { target } = e;
      const html = document.querySelector(target.dataset.jsShowOfferInfo).innerHTML;
      jsKit.openModal(html, { size: 'modal-xl' });
    },

    // krok 1, wybór ducha
    selectGhost: async (e) => {
      const [ghostId, ghostFilterId = false] = getEventDataParts(e, 'jsGhostParams');
      debug(`selectGhost(${ghostId}, ${ghostFilterId})`);

      if (ghostId) {
        const url = ghostFilterId ? `/wizard/selectGhost/${ghostId}/${ghostFilterId}` : `/wizard/selectGhost/${ghostId}`;
        const data = await jsKit.requestUrl(url);
        if (data?.redirect) {
          window.location = data.redirect;
        } else {
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // krok 2, wybór produktu do ducha
    selectProduct: async (e) => {
      const { target } = e;
      const [clickableId, productId] = jsKit.getDataParts(target, 'jsProductSelect');

      debug(`selectProduct(${clickableId}, ${productId})`);
      if (target.tagName.toLowerCase() === 'button' && !target.classList.contains('stretched-link')) {
        target.classList.add('loading', 'active');
        document.querySelector(`#btn-check-${productId}`).checked = true;
      } else if (target.tagName.toLowerCase() === 'input') {
        target.nextElementSibling.classList.add('loading');
      }

      const clickableIconWrapper = document.querySelector(`#clickable_icon_${clickableId}`);
      const clickableIcon = clickableIconWrapper.querySelector('i');
      jsKit.disposeTooltip(clickableIcon);

      if (clickableId && productId) {
        const url = `/wizard/selectProduct/${productId}`;
        const data = await jsKit.requestUrl(url);
        if (!data) return;

        if (target.tagName.toLowerCase() === 'input') {
          target.nextElementSibling.classList.remove('loading');
        }

        await jsKit.handleValidatedResponse(data, {
          onValid: async ({ icon_content }) => {
            jsKit.setHtml(clickableIconWrapper, icon_content);
            jsKit.initTooltipsIn(clickableIconWrapper);
            await kitman.loadPicturesForGhost();
            await kitman.refreshGhostHiddenPictures();
          },
          errorType: 'error',
        });
      }
    },

    // krok 2, pokazuje popup ze szczegółami produktu
    showKitbuilderProduct: async (e) => {
      const productId = e.target.dataset.jsProductId;
      const { target } = e;
      debug(`showKitbuilderProduct(${productId})`);

      jsKit.setLoading(target);
      const initProductGallerySwiper = () => {
        const modal = document.querySelector(jsKit.defaults.modalID);
        if (!modal.querySelector('[data-thumb]')) return;
        const thumbs = modal.querySelectorAll('[data-thumb]');
        const activeClass = 'border-primary';
        const removeActiveClass = (className) => thumbs.forEach((thumb) => thumb.classList.remove(className));
        const gallerySwiper = new Swiper('#swiper-product-gallery', {
          on: {
            slideChangeTransitionStart() {
              removeActiveClass(activeClass);
              thumbs[gallerySwiper.activeIndex].classList.add(activeClass);
            },
          },
        });

        thumbs[0].classList.add(activeClass);

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', (evt) => {
            gallerySwiper.slideTo(jsKit.getIndex(thumbs, evt.target), 500);
          });
        });
      };

      if (productId) {
        const url = `/wizard/showKitbuilderProduct/${productId}`;

        const data = await jsKit.requestUrl(url, 'text');

        if (data) {
          jsKit.setLoading(target, false);
          jsKit.openModal(data, { shownCB: initProductGallerySwiper });
        }
      }
    },

    toggleSideMenu: (elemId, keepOpened = false) => {
      debug(`toggleSideMenu(${elemId})`);
      const sideMenu = document.querySelector(elemId);
      if (sideMenu.classList.contains('shown') && !keepOpened) {
        sideMenu.classList.remove('shown');
      } else {
        sideMenu.classList.add('shown');
      }
    },

    // krok 5,
    removeSetFromKitmanBasket: async (e) => {
      const setId = (e.delegateTarget || e.target).dataset.jsRemoveSetFromKitmanBasket;
      debug(`removeSetFromKitmanBasket(${setId})`);

      const url = `/wizard/removeSetFromKitmanBasket/${setId}`;
      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: async ({ redirect, ga4_event: ga4Event }) => {
          await kitman.GA4Event.reportBasketResult(ga4Event);
          document.location = redirect;
        },
        errorType: 'error',
      });
    },

    // krok 5,
    editSetFromKitmanBasket: async (e) => {
      const setId = e.target.dataset.jsEditSetFromKitmanBasket;
      debug(`editSetFromKitmanBasket(${setId})`);

      const url = `/wizard/editSetFromKitmanBasket/${setId}`;
      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ redirect }) => document.location = redirect,
        errorType: 'error',
      });
    },

    editSetCurrentFromKitmanBasket: async (e) => {
      const editBtn = document.querySelector('[data-js-edit-set-from-kitman-basket]');
      const setId = editBtn.dataset.jsEditSetFromKitmanBasket;
      debug(`editSetCurrentFromKitmanBasket(${setId})`);

      setButtonLoading(e.target);

      const url = `/wizard/editSetFromKitmanBasket/${setId}`;
      const data = await jsKit.requestUrl(url);
      setButtonLoading(e.target, false);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ redirect }) => document.location = redirect,
        errorType: 'error',
      });
    },

    // krok 5,
    removeDiscountCoupon: async (e) => {
      const coupon = e.target.dataset.jsRemoveDiscountCoupon;
      debug(`removeDiscountCoupon(${coupon})`);

      const url = `/wizard/removeDiscountCoupon/`;
      const body = { coupon };
      await jsKit.requestUrl(url, 'json', 'POST', body);
      document.location.reload();
    },

    // krok 5,
    closeDiscountCouponPanel: async () => {
      debug('closeDiscountCouponPanel()');

      const url = '/wizard/closeDiscountCouponPanel/';
      const data = await jsKit.requestUrl(url, 'text');
      jsKit.setHtml('#discount-panel', data);
    },

    // krok 5,
    checkDiscountCoupon: async (e) => {
      debug('checkDiscountCoupon()');

      e.preventDefault();
      setButtonLoading(e.target);

      const url = '/wizard/checkDiscountCoupon/';
      const discountCouponCode = document.querySelector('#discount_coupon_code_text');
      if (discountCouponCode.value === '') {
        discountCouponCode.focus();
        setButtonLoading(e.target, false);
        return;
      }
      const form = document.querySelector('#basket_discount_coupon_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      setButtonLoading(e.target, false);
      if (data.validated) {
        document.location.reload();
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // krok 5,
    clearSlotInOutfitsInKitmanBasket: async (e) => {
      const [setId, slotKey] = getEventDataParts(e, 'jsClearSlotInOutfitsInKitmanBasket');
      debug(`clearSlotInOutfitsInKitmanBasket(${setId}, ${slotKey})`);

      const url = `/wizard/clearSlotInOutfitsInKitmanBasket/${setId}/${slotKey}`;
      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: () => window.location.reload(),
        errorType: 'error',
      });
    },

    // krok 5,
    loadDiscountCouponPanel: async (e) => {
      const [status, type] = getEventDataParts(e, 'jsLoadDiscountCouponPanel');
      debug(`loadDiscountCouponPanel(${status}, ${type})`);

      const url = `/wizard/loadDiscountCouponPanel/${status}/${type}`;
      const discountPanel = document.querySelector('#discount-panel');
      const data = await jsKit.requestUrl(url, 'text');
      if (data) {
        jsKit.setHtml(discountPanel, data);
        discountPanel.querySelector('#discount_coupon_code_text').focus();
      }
    },

    // krok 3, wyświetlenie w modalu produktu z nadrukami
    enlargeProduct: async (e) => {
      const id = e.target.dataset.jsEnlargeProduct;
      debug(`enlargeProduct(${id})`);
      jsKit.openModal(document.querySelector(`#${id}`).innerHTML);
    },

    // odświeżanie obrazkó produktów na duchu
    loadPicturesForGhost: async () => {
      debug('loadPicturesForGhost()');
      const url = '/wizard/loadPicturesForGhost/';

      const data = await jsKit.requestUrl(url);

      if (data) {
        if (data.html) {
          jsKit.setHtml('#panel_ghost_pictures', data.html);
        } else {
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // send reset password link
    kitmanPasswordForgot: async (e) => {
      debug('kitmanPasswordForgot()');

      e.preventDefault();
      setButtonLoading(e.target);

      const url = '/wizard/passwordForgot';
      const form = document.querySelector('#forgot_password_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      if (data) {
        setButtonLoading(e.target, false);

        if (data.validated) {
          jsKit.closeModal();
          jsKit.showNotificationsPanel(data.success_message);
        } else {
          jsKit.showErrors(data);
        }
      }
    },

    // rejestracja klienta w Kitmanie
    clientRegisterKitman: async (e) => {
      debug('clientRegisterKitman()');
      e.preventDefault();
      const form = document.querySelector('#register_form');

      const formIsInvalid = Array.from(form.querySelectorAll('[data-js-validate][data-js-invalid-text]')).map((input) => jsKit.validateInput(input));
      if (formIsInvalid.some((value) => value === false)) {
        return;
      }

      const { target } = e;

      setButtonLoading(target);

      const url = '/wizard/registerKitman';
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      setButtonLoading(target, false);

      if (data) {
        if (data.validated) {
          window.location.reload();
        } else {
          jsKit.showErrors(data);
        }
      }
    },

    editKitbuilderSet: async (e) => {
      const setId = e.target.dataset.jsEditKitbuilderSet;
      debug(`editKitbuilderSet(${setId})`);
      e.preventDefault();

      const url = `/wizard/editKitbuilderSet/${setId}`;
      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ redirect }) => document.location = redirect,
        errorType: 'error',
      });
    },

    // logowanie klienta w Kitmanie
    loginClientKitman: async (e) => {
      debug('loginClientKitman()');
      e.preventDefault();
      const { target } = e;
      setButtonLoading(target);

      const url = '/wizard/loginClientKitman';
      const form = document.querySelector('#login_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      target.disabled = false;

      if (data) {
        if (data.validated) {
          if (data.add_to_basket) {
            await kitman.addSetToKitmanBasket();
            target.classList.remove('loading');
          } else if (data.reload) {
            window.location.reload();
          } else if (data.location) {
            document.location = data.location;
          }
        } else {
          target.classList.remove('loading');
          jsKit.showErrors(data);
        }
      }
    },

    // odświeżanie ukrytych zdjęć do ducha
    refreshGhostHiddenPictures: async () => {
      debug('refreshGhostHiddenPictures()');
      const url = '/wizard/refreshGhostHiddenPictures/';

      const data = await jsKit.requestUrl(url);

      if (data) {
        if (data.html) {
          jsKit.setHtml('#hidden_ghost_pictures', data.html);
        } else {
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // wybieranie rozmiaru dla produktu w stroju
    selectProductOption: async (e) => {
      const [optionId, stockAmount] = getEventDataParts(e, 'jsSelectProductOptionChange');
      debug(`selectProductOption(${optionId}, ${stockAmount})`);

      if (!stockAmount) {
        jsKit.showNotificationsPanel('Ten rozmiar jest już niedostępny.');
      } else if (optionId) {
        const url = `/wizard/selectProductOption/${optionId}`;

        const data = await jsKit.requestUrl(url);

        if (data) {
          if (data.validated) {
            if (data.html) {
              jsKit.setHtml('#panel_options', data.html);
            } else {
              document.getElementById(`option_${optionId}`).checked = true;
            }
          } else {
            jsKit.showNotificationsPanel(data.error_message);
          }
        }
      }
    },

    // wybieranie rozmiaru dla produktu w stroju - w popupie z ustawieniami
    selectProductOptionSettings: async (e) => {
      const [outfitId, clickableId, optionId, stockAmount] = getEventDataParts(e, 'jsSelectProductOptionSettingsChange');
      debug(`selectProductOptionSettings(${outfitId}, ${clickableId}, ${optionId}, ${stockAmount})`);

      if (stockAmount === 0) {
        jsKit.showNotificationsPanel('Ten rozmiar jest już niedostępny.');
      } else if (outfitId && clickableId && optionId) {
        const url = `/wizard/selectProductOptionSettings/${outfitId}/${clickableId}/${optionId}`;

        const data = await jsKit.requestUrl(url);

        if (data) {
          if (data.validated) {
            // odświeżamy analogiczne panele we wszystkich strojach
            if (data.panels) {
              data.panels.forEach((panel) => {
                jsKit.setHtml(`#panel_options_${panel.outfit_id}_${clickableId}`, panel.html);
              });
            }
          } else {
            jsKit.showNotificationsPanel(data.error_message);
          }
        }
      }
    },

    // odświeża panel z podsumowaniem zestawu
    loadSummaryPanel: async () => {
      debug('loadSummaryPanel()');

      const url = '/wizard/loadSummaryPanel/';

      const data = await jsKit.requestUrl(url);

      if (data) {
        if (data.html) {
          jsKit.setHtml('#panel_summary', data.html);
        } else {
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // step3: czyszczenie slotu wzorcowego
    clearSlot: async (e) => {
      const slotId = e.target.dataset.jsClearSlot;
      debug(`clearSlot(${slotId})`);

      jsKit.disposeTooltip(e.target);

      if (slotId) {
        const url = `/wizard/clearSlot/${slotId}`;

        const data = await jsKit.requestUrl(url);

        if (data.validated) {
            // przeładowujemy zmieniony slot w produkcie
          updateSlotContent(data);

            // przełądowanie formularza slotu
          await kitman.loadKitbuilderSlot(data.view_id, data.slot_id);

            // przeładowanie panelu z podsumowaniem zestawu
          await kitman.loadSummaryPanel();
        }
      }
    },

    // step4: czyszczenie slotu wzorcowego per strój
    clearSlotItem: async (e) => {
      const slotId = e.target.dataset.jsClearSlotItem;
      debug(`clearSlotItem(${slotId})`);

      jsKit.disposeTooltip(e.target);

      if (slotId) {
        const url = `/wizard/clearSlotItem/${slotId}`;

        const data = await jsKit.requestUrl(url);

        if (data.validated) {
            // przeładowujemy zmieniony slot w produkcie
          updateSlotContent(data);

            // przełądowanie formularza slotu
          await kitman.loadKitbuilderSlotItem(data.view_id, data.slot_id);

            // przeładowanie panelu z podsumowaniem zestawu
          await kitman.loadSummaryPanel();

          await kitman.loadOutfitThumbnail();
        }
      }
    },

    saveKitbuilderSlotRadioControl: (e) => {
      const { target } = e;
      debug(`saveKitbuilderSlotRadioControl(${target})`);
      const radio = document.querySelector(target.dataset.jsSaveKitbuilderSlotRadioControl);
      const collapse = document.querySelector(target.dataset.bsTarget);
      const firstRadioInCollapse = collapse.querySelector('.btn-check');
      const event = new Event('change', {
        bubbles: true,
        cancelable: true,
      });
      if (target.classList.contains('collapsed')) {
        radio.checked = true;
        radio.dispatchEvent(event);
      } else {
        firstRadioInCollapse.checked = true;
        firstRadioInCollapse.dispatchEvent(event);
      }
    },

    // zapisuje zawartość slotu generalnego
    saveKitbuilderSlot: async (e) => {
      const { target } = e;
      if (defaults.debugMode) {
        console.log(`saveKitbuilderSlot(${target})`);
      }

      const url = '/wizard/saveKitbuilderSlot';
      const form = document.querySelector('#slot_form');
      const formData = new FormData(form);
      saveFiltersScrollTop();

      if (target) {
        updateSlotRadioState(target);
        if (target.tagName === 'button') {
          jsKit.setLoading(target);
        }
      }

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      if (target && target.tagName === 'button') {
        jsKit.setLoading(target, false);
      }

      if (data.validated) {
          // przeładowujemy zmieniony slot w produkcie
        renderSlotContent(data);

          // przeładowanie panelu z podsumowaniem zestawu
        await kitman.loadSummaryPanel();
        await kitman.loadKitbuilderSlot(data.view_id, data.slot_id);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // zapisuje zawartość slotu w konkretnym stroju
    saveKitbuilderSlotItemSettings: async (e) => {
      const { target } = e;
      const formIDSuffix = target.dataset.jsSaveKitbuilderSlotItemSettings;

      if (defaults.debugMode) {
        console.log(`saveKitbuilderSlotItemSettings(${formIDSuffix})`);
      }

      const url = '/wizard/saveKitbuilderSlotItemSettings';
      const form = document.querySelector(`#slot_form_${formIDSuffix}`);
      const formData = new FormData(form);

      if (target) {
        updateSlotRadioState(target, form, formIDSuffix);
      }

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      if (data.validated) {
        // jsKit.showNotificationsPanel(data.success_message, 'success');
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // odświeża widok miniatury stroju na liście strojów
    loadOutfitThumbnail: async () => {
      debug('loadOutfitThumbnail');

      const url = '/wizard/loadOutfitThumbnail/';

      const data = await jsKit.requestUrl(url);

      if (data) {
        if (data.html) {
          jsKit.setHtml(`#outfit_thumbnail_${data.outfit_id}`, data.html);
        } else {
          // pokaż błędy
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // zapisuje zawartość slotu w konkretnym stroju
    saveKitbuilderSlotItem: async (e) => {
      const { target } = e;
      if (defaults.debugMode) {
        console.log('saveKitbuilderSlotItem');
      }

      const url = '/wizard/saveKitbuilderSlotItem';
      const form = document.querySelector('#slot_form');
      const formData = new FormData(form);
      saveFiltersScrollTop();

      if (target) {
        updateSlotRadioState(target);
        if (target.tagName === 'button') {
          jsKit.setLoading(target);
        }
      }

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      if (target && target.tagName === 'button') {
        jsKit.setLoading(target, false);
      }

      if (data.validated) {
          // przeładowujemy zmieniony slot w produkcie
        renderSlotContent(data, 'slot_content');

          // przeładowanie panelu z podsumowaniem zestawu
        await kitman.loadSummaryPanel();

        await kitman.loadOutfitThumbnail();
        await kitman.loadKitbuilderSlotItem(data.view_id, data.slot_id);

          // jsKit.showNotificationsPanel(data.success_message, 'success');
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // walidacja kroku kitbuldera - czy wszystko zostało poprawnie skonstruowane
    validateKitbuilderStep: async (e) => {
      const step = e.target.dataset.jsValidateKitbuilderStep;
      const { target } = e;
      debug(`validateKitbuilderStep(${step})`);
      jsKit.setLoading(target);

      if (step) {
        const url = `/wizard/validateKitbuilderStep/${step}`;
        const data = await jsKit.requestUrl(url);
        jsKit.setLoading(target, false);

        await jsKit.handleValidatedResponse(data, {
          onValid: (validData) => {
            if (validData.popup && validData.html) {
              jsKit.openModal(validData.html);
            } else if (validData.redirect) {
              window.location = validData.redirect;
            }
          },
          onInvalid: (invalidData) => {
            if (invalidData.html) {
              jsKit.openModal(invalidData.html);
            }
          },
          showError: false,
        });
      }
    },

    // pokazuje popup z ustawieniami
    showSettings: async (e) => {
      debug('showSettings', e.target);
      setButtonLoading(e.target);
      const url = '/wizard/showSettingsPopup/';

      const data = await jsKit.requestUrl(url, 'text');

      if (data) {
        jsKit.openModal(data, { keyboard: false, backdrop: 'static' });
        setButtonLoading(e.target, false);
      }
    },

    // zmiana nazwy stroju
    renameOutfit: async (e) => {
      const [outfitId, formPrefix] = getEventDataParts(e, 'jsRenameOutfitInput');
      debug(`renameOutfit(${outfitId}, ${formPrefix})`);

      const url = '/wizard/renameOutfit';
      const formId = `#${formPrefix}${outfitId}`;
      const form = document.querySelector(formId);
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      if (!data.validated) {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // odświeża zawartość popupu z ustawieniami
    loadSettings: async () => {
      debug('const loadSettings()');

      const url = '/wizard/loadSettingsPopup/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml('#panel_settings', data.html);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // usuwa strój z panelu Ustawienia
    settingsRemoveOutfit: async (e) => {
      const outfitId = e.target.dataset.jsSettingsRemoveOutfit;
      debug(`settingsRemoveOutfit(${outfitId})`);

      if (outfitId) {
        const url = `/wizard/removeOutfit/${outfitId}`;

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          // przeładowanie popupu z ustawieniami
          kitman.loadSettings();
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    // odświeża zawartość stroju popupie z ustawieniami
    loadSettingsOutfit: async (outfitId) => {
      debug(`settingsRemoveOutfit(${outfitId})`);

      if (outfitId) {
        const url = `/wizard/loadSettingsOutfit/${outfitId}`;

        const data = await jsKit.requestUrl(url);
        if (data.html) {
          jsKit.setHtml(`#outfit_settings_${outfitId}`, data.html);
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    // usuwa wybrany produkt podanego stroju
    settingsClearClickable: async (e) => {
      const [clickableId, outfitId] = getEventDataParts(e, 'jsSettingsClearClickable');
      debug(`settingsClearClickable(${outfitId}, ${clickableId})`);

      if (clickableId && outfitId) {
        const url = `/wizard/settingsClearClickable/${clickableId}/${outfitId}`;

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          // przeładowanie panelu ze strojem w popupie z ustawieniami
          await kitman.loadSettingsOutfit(outfitId);
        } else {
          jsKit.showNotificationsPanel(data.error_message);
        }
      }
    },

    // odświeżenie produktu (zawartości bieżącego obszaru klikalnego)
    loadKitbuilderProduct: async () => {
      debug('loadKitbuilderProduct()');
      const url = '/wizard/loadKitbuilderProduct/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml('#panel_products', data.html);
        swipers.initPrintZoneSwiper();
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // wybór obszaru klikalnego na duchu (krok 3)
    selectClickable3: async (clickableId) => {
      if (clickableId) {
        const url = `/wizard/selectClickable/${clickableId}`;

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          await kitman.loadKitbuilderProduct();
          await kitman.loadKitbuilderSlot(data.product_view_id, 1);
          await kitman.loadGhostViewDefault(0);
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    // wybór obszaru klikalnego na duchu (krok 4)
    selectClickable4: async (e) => {
      const clickableId = e.target.dataset.jsSelectClickable4;
      if (clickableId) {
        const url = `/wizard/selectClickable/${clickableId}/1`;

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          await kitman.loadKitbuilderProductItem();
          await kitman.loadKitbuilderSlotItem(data.product_view_id, 1);
          await kitman.loadGhostViewDefault(true);
          await kitman.loadOutfitsViewDefault();
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    // dodaje strój z panelu Ustawienia
    settingsAddOutfit: async () => {
      const url = '/wizard/addOutfit/';

      const data = await jsKit.requestUrl(url);
      if (data.validated) {
        await kitman.loadSettings();
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // ladowanie
    addLoader: (e) => {
      const [containerID, cbFn] = getEventDataParts(e, 'jsAddLoader');
      debug(`addLoader(${containerID}, ${cbFn})`);
      const reloadPage = () => document.location.reload();

      if (document.querySelector(containerID)) {
        const container = document.querySelector(containerID);
        container.classList.add('loading');
        if (cbFn === 'reloadPage') { reloadPage(); }
      }
    },

    // dodaje bieżący zestaw do koszyka Kitmana - z pominięciem błedów niekrytycznych
    forceAddSetToKitmanBasket: async () => {
      const url = '/wizard/forceAddSetToKitmanBasket/';

      const data = await jsKit.requestUrl(url);
      if (data.validated) {
        await kitman.GA4Event.reportBasketResult(data.ga4_event);
        window.location = data.redirect;
      } else if (data.html) {
        jsKit.setHtml('#popup_container_large', '');
        jsKit.openModal(data.html);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // pokazuje popup z rozmiarówką dla produktu

    showProductSizes: async (e) => {
      const productId = e.target.dataset.jsShowProductSizes;
      if (productId) {
        const url = `/wizard/showProductSizes/${productId}`;
        const data = await jsKit.requestUrl(url, 'text');

        if (data) {
          jsKit.openModal(data);
        }
      }
    },

    // wypełnia podany obszar klikalny domyślnym produktem
    fillClickable: async (e) => {
      const clickableId = e.target.dataset.jsFillClickable;
      if (defaults.debugMode) {
        console.log(`fillClickable(${clickableId})`);
      }

      jsKit.disposeTooltip(e.target);

      if (clickableId) {
        const url = `/wizard/fillClickable/${clickableId}`;

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          jsKit.setHtml(`#clickable_icon_${clickableId}`, data.icon_content);

          await refreshOutfitView(data.product_view_id, {
            refreshThumbnail: true,
            refreshSummary: true,
            refreshHiddenPictures: true,
          });
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    // pokazuje domyslny widok z ducha
    loadGhostViewDefault: async (item) => {
      debug(`loadGhostViewDefault(${item})`);

      const url = `/wizard/loadGhostViewDefault/${item}`;

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml('#panel_ghost_pictures', data.html);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // odświeżenie produktu (zawartości bieżącego obszaru klikalnego) w konkretnym stroju
    loadKitbuilderProductItem: async () => {
      debug('loadKitbuilderProductItem()');

      const url = '/wizard/loadKitbuilderProductItem/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml('#panel_products', data.html);
        swipers.initPrintZoneSwiper();
          // ustawienie odpowiedniego widoku na swiperze dla stroju
        const playerViews = document.querySelector('#panel_ghost_pictures');
        const player = playerViews.querySelector('.player-view');
        const currentGhostID = player.dataset.ghostView;
        const hiddenPlayerViews = document.querySelector('#hidden_ghost_pictures');
        const hiddenPlayer = hiddenPlayerViews.querySelectorAll('.player-view');
        const currentView = [...hiddenPlayer].filter((elem) => elem.dataset.ghostView === currentGhostID);
        swipers.zoneSwiper.slideTo(jsKit.getIndex(hiddenPlayer, currentView[0]), 500);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // ładowanie formularza dla slotu
    loadKitbuilderSlotItem: async (view, slot) => {
      debug(`loadKitbuilderSlotItem(${view}, ${slot})`);

      await loadSlotForm({
        view,
        slot,
        dataAttr: 'jsSlotItemParams',
        urlPrefix: '/wizard/loadKitbuilderSlotItem',
      });
    },

    // ładowanie formularza dla slotu
    loadKitbuilderSlot: async (view, slot) => {
      debug(`loadKitbuilderSlot(${view}, ${slot})`);

      await loadSlotForm({
        view,
        slot,
        dataAttr: 'jsSlotParams',
        urlPrefix: '/wizard/loadKitbuilderSlot',
      });
    },

    // ładuje bieżący widok listy strojów
    loadOutfitsViewDefault: async () => {
      debug('loadOutfitsViewDefault()');

      const url = '/wizard/loadOutfitsPanel/';
      const outfitsList = document.querySelector('#outfits_list');
      jsKit.setLoading(outfitsList);

      const data = await jsKit.requestUrl(url);
      if (data) {
        jsKit.setLoading(outfitsList, false);
      }
      if (data.html) {
        jsKit.setHtml(outfitsList, data.html);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // odświeża zestaw obszarów klikalnych w duchu w kroku 4
    loadGhostClickables: async () => {
      debug('loadGhostClickables()');

      const url = '/wizard/loadGhostClickables/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        const ghostClickables = jsKit.setHtml('#ghost_clickables', data.html);
        jsKit.initTooltipsIn(ghostClickables);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    uploadKitbuilderGraphicFile: async () => {
      debug('uploadKitbuilderGraphicFile()');

      const url = '/wizard/uploadKitbuilderImage/';
      const form = document.querySelector('#slot_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      if (data.validated) {
          // przeładowujemy zmieniony slot w produkcie
        renderSlotContent(data);

          // przeładowanie panelu z podsumowaniem zestawu
        await kitman.loadSummaryPanel();
        await kitman.loadKitbuilderSlot(data.view_id, data.slot_id);
      } else {
        jsKit.showNotificationsPanel(data.error.kitbuilder_picture, 'error');
      }
    },

    // wybór stroju
    selectOutfit: async (e) => {
      const outfitId = e.target.dataset.jsSelectOutfit;
      if (defaults.debugMode) {
        console.log(`selectOutfit(${outfitId})`);
      }

      if (outfitId) {
        const url = `/wizard/selectOutfit/${outfitId}`;

        const outfitsList = document.querySelector('#outfits_list');
        [...outfitsList.querySelectorAll('.swiper-slide')].forEach((slide) => {
          slide.classList.remove('border-primary');
        });
        document.querySelector(`#outfit_slide_${outfitId}`).classList.add('border-primary');

        const data = await jsKit.requestUrl(url);
        if (data.validated) {
          await refreshOutfitView(data.product_view_id, {
            reloadOutfits: true,
          });
        } else {
          jsKit.showNotificationsPanel(data.error_message, 'error');
        }
      }
    },

    logoutClientKitman: async (e) => {
      debug('logoutClientKitman()');

      const url = '/wizard/logoutClientKitman/';
      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ redirect }) => window.location = redirect,
        errorType: 'error',
      });
    },

    kitmanPasswordReset: async (e) => {
      debug('kitmanPasswordReset()');
      e.preventDefault();
      const form = document.querySelector('#reset_password_form');

      if (!jsKit.validateForm(form)) return;

      const { target } = e;
      setButtonLoading(target);

      const url = '/wizard/passwordReset';
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      target.disabled = false;

      await jsKit.handleValidatedResponse(data, {
        onValid: ({ location }) => document.location = location,
        onInvalid: (invalidData) => {
          jsKit.showNotificationsPanel(invalidData.error_message, 'error');
          jsKit.setLoading(target, false);
          jsKit.showErrors(invalidData, '#reset_password_form');
        },
      });
    },

    // pokazuje popup z formularzem rejestracji
    showRegisterForm: async (e) => {
      debug('showRegisterForm()');

      const target = e.target;
      const url = '/wizard/showRegisterForm/' + (target.getAttribute('data-basket') || '');
      jsKit.setLoading(target, true, { className: 'disabled' });

      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: async ({ html }) => {
          jsKit.openModal(html);
          jsKit.setLoading(target, false, { className: 'disabled' });
          await appendOAuthComponents();
        },
        errorType: 'error',
      });
    },

    // Pokazuje popup z formularzem resetu hasła
    showPasswordForgotForm: async (e) => {
      debug('showPasswordForgotForm()');
      const target = e.target;
      const url = '/wizard/showPasswordForgotForm/';
      jsKit.setLoading(target, true, { className: 'disabled' });

      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ html }) => {
          jsKit.openModal(html);
          jsKit.setLoading(target, false, { className: 'disabled' });
        },
        errorType: 'error',
      });
    },


    // pokazuje popup z formularzem logowania
    showLoginForm: async (e, context) => {
      debug('showLoginForm()');

      const target = e.target;
      const url = '/wizard/showLoginForm/' + ((context || {}).basket || '');
      jsKit.setLoading(target, true, { className: 'disabled' });

      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: async ({ html }) => {
          jsKit.openModal(html);
          jsKit.setLoading(target, false, { className: 'disabled' });
          await appendOAuthComponents();
        },
        errorType: 'error',
      });
    },

    // dodaje bieżący zestaw do koszyka Kitmana
    addSetToKitmanBasket: async (e = null) => {
      debug('addSetToKitmanBasket()');
      const target = e?.delegateTarget || e?.target;
      setButtonLoading(target);
      const url = '/wizard/addSetToKitmanBasket/';

      const data = await jsKit.requestUrl(url);
      setButtonLoading(target, false);

      if (data.validated) {
        if (data.show_login && e) {
          await kitman.showLoginForm(e, { basket: 1 });
        } else {
          await kitman.GA4Event.reportBasketResult(data.ga4_event);
          window.location = data.redirect;
        }
      } else if (data.html) {
        jsKit.openModal(data.html);
      } else {
        jsKit.showNotificationsPanel(data.error_message);
      }
    },

    // dodaje nowy strój
    addOutfit: async () => {
      debug('addOutfit()');

      const url = '/wizard/addOutfit/';
      const data = await jsKit.requestUrl(url);

      await jsKit.handleValidatedResponse(data, {
        onValid: async () => {
          await kitman.loadOutfitsViewDefault();
          await kitman.loadSummaryPanel();
        },
        errorType: 'error',
      });
    },

    // przejście do wybranego kroku procesu
    loadKitbuilderStep: async (e) => {
      const step = e.target.dataset.jsLoadKitbuilderStep;
      debug(`loadKitbuilderStep(${step})`);

      if (step) {
        setButtonLoading(e.target);

        const url = `/wizard/loadKitbuilderStep/${step}`;
        const data = await jsKit.requestUrl(url);
        setButtonLoading(e.target, false);

        await jsKit.handleValidatedResponse(data, {
          onValid: ({ redirect }) => window.location = redirect,
          errorType: 'error',
        });
      }
    },

    // usuwa strój
    removeOutfit: async (e) => {
      const outfitId = e.target.dataset.jsRemoveOutfit;
      debug(`removeOutfit(${outfitId})`);
      if (outfitId) {
        const url = `/wizard/removeOutfit/${outfitId}`;
        const data = await jsKit.requestUrl(url);

        await jsKit.handleValidatedResponse(data, {
          onValid: async () => {
            await kitman.loadOutfitsViewDefault();
            await kitman.loadSummaryPanel();
          },
          errorType: 'error',
        });
      }
    },

    // odświeżenie listy produktów (krok 2)
    loadProducts: async (page = 1) => {
      debug(`loadProducts(${page})`);

      const productListContainer = document.querySelector('#step2_products_list');
      const productsPanel = productListContainer.parentElement;
      jsKit.setLoading(productsPanel);
      const url = `/wizard/loadProducts/${page}`;

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        if (page > 1) {
          productListContainer.innerHTML += data.html;
        } else {
          productListContainer.scrollTop = 0;
          productListContainer.dataset.nextStep = 1;
          jsKit.setHtml(productListContainer, data.html);
          if ('noProducts' in productListContainer.dataset) {
            delete productListContainer.dataset.noProducts;
          }
        }
        if (data.products_amount_left) {
          productListContainer.dataset.nextStep = parseInt(page, 10) + 1;
          if ('noProducts' in productListContainer.dataset) {
            delete productListContainer.dataset.noProducts;
          }
        } else {
          productListContainer.dataset.noProducts = 1;
        }
        jsKit.setLoading(productsPanel, false);
        defaults.step2_products_amount = data.products_amount;
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // odświeżenie listy filtrów (krok 2)
    loadFilters: async () => {
      debug('loadFilters()');
      const filterPanel = document.querySelector('#panel_filters');
      jsKit.setLoading(filterPanel);
      const url = '/wizard/loadFilters/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml(filterPanel, data.html);
        jsKit.setLoading(filterPanel, false);
        jsKit.setHtml('#products_amount', defaults.step2_products_amount);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    // zapisuje frazę do wyszukiwania do filtrów
    selectSearchPhrase: async () => {
      debug('selectSearchPhrase()');
      const url = '/wizard/selectSearchPhrase';
      const form = document.querySelector('#kitman_search_form');
      const formData = new FormData(form);
      setFiltersLoading();

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      await jsKit.handleValidatedResponse(data, {
        onValid: async () => {
          await kitman.loadProducts(1);
          await kitman.loadFilters();
        },
        errorType: 'error',
      });
    },

    // usowa frazę z wyszukiwania do filtrów
    clearSearchPhrase: async () => {
      debug('clearSearchPhrase()');

      document.querySelector('#filters_search_phrase').value = '';
      await kitman.selectSearchPhrase();
    },

    // zmiana nazwy zestawu
    renameSet: async () => {
      debug('renameSet()');

      const url = '/wizard/renameSet';
      const form = document.querySelector('#set_form');
      const formData = new FormData(form);
      await jsKit.requestUrl(url, 'json', 'POST', formData);
    },

    turnGhost: () => {
      debug('turnGhost()');

      const playerViews = document.querySelector('#panel_ghost_pictures');
      const players = playerViews.querySelectorAll('.player-view');
      [...players].forEach((player) => {
        if (player.classList.contains('shown')) {
          player.classList.remove('shown');
          player.classList.add('temp');
        }
        if (!player.classList.contains('temp') && !player.classList.contains('shown')) {
          player.classList.add('shown');
        }
      });
    },

    // pokazuje konkretny widok z ducha
    loadGhostViewById: async (view, item) => {
      debug(`loadGhostViewById(${view}, ${item})`);

      const playerViews = document.querySelector('#panel_ghost_pictures');
      const player = playerViews.querySelector('.player-view');
      const currentGhostID = player.dataset.ghostView;
      const hiddenPlayerViews = document.querySelector('#hidden_ghost_pictures');
      const hiddenPlayer = hiddenPlayerViews.querySelectorAll('.player-view');
      const nextView = [...hiddenPlayer].filter((elem) => elem.dataset.ghostView !== currentGhostID);
      const rotateBtns = document.querySelectorAll('[data-js-ghost-view]');

      rotateBtns.forEach((rotateBtn) => {
        rotateBtn.disabled = true;
      });

      // animacja
      playerViews.appendChild(nextView[0].cloneNode(true));
      setTimeout(kitman.turnGhost, 1);

      const urlPrefix = item ? '/wizard/loadGhostViewById' : '/wizard/loadGhostView';
      const url = `${urlPrefix}/${view}/${item}`;

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        setTimeout(() => {
          jsKit.setHtml(playerViews, data.html);
          // przeładowujemy liste strojów (tylko w kroku 4)
          if (item) {
            kitman.loadOutfitsViewDefault();
          }
          rotateBtns.forEach((rotateBtn) => {
            rotateBtn.disabled = false;
          });
        }, 600);
      } else {
        jsKit.showNotificationsPanel(data.error_message, 'error');
      }
    },

    loadGhostView: async (e) => {
      const [type, swiper = 0] = getEventDataParts(e, 'jsGhostView');
      debug(`loadGhostView(${type}, ${swiper})`);

      const playerViews = document.querySelector('#panel_ghost_pictures');
      const player = playerViews.querySelector('.player-view');
      const currentGhostID = player.dataset.ghostView;
      const hiddenPlayerViews = document.querySelector('#hidden_ghost_pictures');
      const hiddenPlayer = hiddenPlayerViews.querySelectorAll('.player-view');
      const nextView = [...hiddenPlayer].filter((elem) => elem.dataset.ghostView !== currentGhostID);

      if (swiper) {
        // krok 3 i 4, przewinięcie swiera wywołuje metodę kitman.loadGhostViewById
        swipers.zoneSwiper.slideTo(jsKit.getIndex(hiddenPlayer, nextView[0]), 500);
      } else {
        // krok 2, jeżeli nie ma swipera
        await kitman.loadGhostViewById(type, 0);
      }
    },

    // ustawia w sesji info, że klient nie chce się zalogować
    setNoLogin: async (e) => {
      debug('setNoLogin');

      const addToBasket = e.target.dataset.jsSetNoLogin;
      const url = '/wizard/setNoLogin/';

      const data = await jsKit.requestUrl(url);
      if (data.validated) {
        if (addToBasket) {
          await kitman.addSetToKitmanBasket(e);
        }
      }

      jsKit.closeModal();
    },

    clearPriceInputParam: () => {
      if (defaults.debugMode) {
        console.log('clearPriceInputParam');
      }

      const priceFrom = document.querySelector('#filters_price_from');
      const priceTo = document.querySelector('#filters_price_to');
      priceFrom.value = '';
      priceTo.value = '';
      kitman.selectPriceRange();
    },

    loadProductsAndFilters: async (url, form = '') => {
      debug(`loadProductsAndFilters(${url})`);

      let method = 'GET';
      let dataToSend = null;
      if (form) {
        method = 'POST';
        dataToSend = new FormData(form);
      }

      const data = await jsKit.requestUrl(url, 'json', method, dataToSend);
      await jsKit.handleValidatedResponse(data, {
        onValid: async () => {
          // odświeżamy listę produktów
          await kitman.loadProducts(1);
          // przeładowanie listy filtrów
          await kitman.loadFilters();
        },
        errorType: 'error',
      });
    },

    // wybranie opcji do filtrowania w kroku 2 - ROZMIAR
    selectFiltersOptionSize: async (optionId) => {
      debug(`selectFiltersOptionSize(${optionId})`);

      setFiltersLoading();

      if (optionId) {
        const url = '/wizard/selectFiltersOptionSize';
        if (!document.querySelector(`#checkbox_size_${optionId}`).checked) {
          document.querySelector(`#input_size_${optionId}`).value = '';
        }
        const form = document.querySelector(`#kitman_size_form_${optionId}`);
        await kitman.loadProductsAndFilters(url, form);
      }
    },

    // wybranie opcji do filtrowania w kroku 2
    selectFiltersOption: async (e) => {
      const optionId = e.target.dataset.jsSelectFiltersOption;
      debug(`selectFiltersOption(${optionId})`);

      setFiltersLoading();

      if (optionId) {
        const url = `/wizard/selectFiltersOption/${optionId}`;
        await kitman.loadProductsAndFilters(url);
      }
    },

    // wybranie opcji do sortowania w kroku 2
    jsSelectSortingOption: async (e) => {
      let optionId = e.target.querySelector('option:checked');
      if (optionId) {
        optionId = optionId.value;
      }
      debug(`selectSortingOption(${optionId})`);

      setFiltersLoading();
      if (optionId) {
        const url = `/wizard/selectSortingOption/${optionId}`;
        await kitman.loadProductsAndFilters(url);
      }
    },

    // zapisuje zakres cenowy do filtrów
    selectPriceRange: async () => {
      debug('selectPriceRange');

      setFiltersLoading();

      kitman.setPriceCheckboxState();
      const url = '/wizard/selectPriceRange';
      const form = document.querySelector('#kitman_price_form');
      await kitman.loadProductsAndFilters(url, form);
    },

    // usuwamy wybrany filtr
    removeFilterSelected: async (e) => {
      const optionId = e.target.dataset.jsRemoveFilterSelected;
      debug(`removeFilterSelected(${optionId})`);

      if (optionId) {
        const url = `/wizard/removeFilterSelected/${optionId}`;
        await kitman.loadProductsAndFilters(url);
      }
    },

    // czyścimy wszystkie filtry
    clearFilters: async () => {
      debug('clearFilters');

      setFiltersLoading();

      const url = '/wizard/clearFilters/';
      await kitman.loadProductsAndFilters(url);
    },

    // wpisanie ilości w filtr ROZMIAR w kroku 2
    changeFiltersOptionSize: async (e) => {
      const optionId = e.target.dataset.jsChangeFiltersOptionSize;
      debug(`changeFiltersOptionSize(${optionId})`);

      setFiltersLoading();

      if (optionId) {
        const optionAmount = document.querySelector(`#input_size_${optionId}`).value;
        const checkboxSize = document.querySelector(`#checkbox_size_${optionId}`);
        checkboxSize.checked = Boolean(optionAmount);
        await kitman.selectFiltersOptionSize(optionId);
      }
    },

    // zapisuje zestaw
    saveKitbuilderSet: async (e) => {
      const { target } = e;
      debug(`saveKitbuilderSet(${target})`);
      const url = '/wizard/saveKitbuilderSet';

      if (target) {
        jsKit.setLoading(target);
      }

      const form = document.querySelector('#set_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);

      await jsKit.handleValidatedResponse(data, {
        onValid: ({ redirect }) => window.location = redirect,
        onInvalid: (invalidData) => {
          // jsKit.showNotificationsPanel(data.error_message, 'error');
          jsKit.showErrors(invalidData, '#set_form');
          if (target) {
            jsKit.setLoading(target, false);
          }
        },
      });
    },

    trigerProductSelect: (e) => {
      const radio = document.querySelector(`#${e.target.dataset.jsTrigerProductSelect}`);
      radio.checked = true;
    },

    // wybór obszaru klikalnego na duchu (krok 2)
    selectClickable: async (clickableId) => {
      if (clickableId) {
        const url = `/wizard/selectClickable/${clickableId}`;
        await kitman.loadProductsAndFilters(url);
      }
    },

    // odświeżanie ukrytych zdjęć do ducha - w konkretnym stroju
    refreshGhostHiddenPicturesOutfit: async () => {
      debug('refreshGhostHiddenPicturesOutfit');
      const url = '/wizard/refreshGhostHiddenPicturesOutfit/';

      const data = await jsKit.requestUrl(url);
      if (data.html) {
        jsKit.setHtml('#hidden_ghost_pictures', data.html);
      }
    },

    // usuwa wybrany produkt z kroku 2 (item = 0) i 3
    clearClickable: async (e) => {
      const [clickableId, item = 0] = getEventDataParts(e, 'jsClearClickable');
      debug(`clearClickable(${clickableId}, ${item})`);

      jsKit.disposeTooltip(e.target);

      if (clickableId) {
        const url = `/wizard/clearClickable/${clickableId}/${item}`;
        const data = await jsKit.requestUrl(url);
        await jsKit.handleValidatedResponse(data, {
          onValid: async (validData) => {
            if (item) {
              await refreshOutfitView(validData.product_view_id, {
                refreshThumbnail: true,
                refreshSummary: true,
                refreshHiddenPictures: true,
              });
              return;
            }

            await kitman.loadGhostViewDefault(0);
            await kitman.refreshGhostHiddenPictures();
            const clickableIconWrapper = jsKit.setHtml(`#clickable_icon_${clickableId}`, validData.icon_content);
            jsKit.initTooltipsIn(clickableIconWrapper);
            await kitman.selectClickable(clickableId);
          },
          errorType: 'error',
        });
      }
    },

    setPriceCheckboxState: () => {
      if (document.querySelector('#price-filter-label')) {
        if (defaults.debugMode) {
          console.log('setPriceCheckboxState');
        }

        const priceFrom = document.querySelector('#filters_price_from');
        const priceTo = document.querySelector('#filters_price_to');
        const priceCheck = document.querySelector('#price-range-checkbox');

        if (priceFrom.value !== '' || priceTo.value !== '') {
          priceCheck.checked = true;
        }

        if (priceFrom.value === '' && priceTo.value === '') {
          priceCheck.checked = false;
        }
      }
    },

    async showInfo(e) {
      const [objectId, nodeId] = getEventDataParts(e, 'jsShowInfo');
      debug(`showInfo(${objectId}, ${nodeId})`);
      const url = `/wizard/showInfo/${objectId}/${nodeId}`;

      const data = await jsKit.requestUrl(url);
      await jsKit.handleValidatedResponse(data, {
        onValid: ({ html }) => jsKit.openModal(html),
        errorType: 'error',
      });
    },

    async changeDeliveryPriceListCountry() {
      debug('changeDeliveryPriceListCountry');
      const url = '/wizard/changeDeliveryPriceListCountry/';
      const form = document.querySelector('#delivery_pricelist_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      if (data) {
        jsKit.setHtml(form, data.html);
      }
    },

    async showDeliveryPriceLists(e) {
      const { target } = e;
      debug('showDeliveryPriceLists');
      const url = '/wizard/showDeliveryPriceLists/';

      jsKit.setLoading(target);

      const detailsBox = document.querySelector('#price-list-details');
      const form = document.querySelector('#delivery_pricelist_form');
      const formData = new FormData(form);

      const data = await jsKit.requestUrl(url, 'json', 'POST', formData);
      if (data) {
        jsKit.setHtml(detailsBox, data.html);
        jsKit.setLoading(target, false);
      }
    },

    showPasswordResetModal: () => {
      jsKit.openModal(document.querySelector('#password_reset').innerHTML);
      document.querySelector('#password_reset').remove();
    },

    resetPasswordSuccess: () => {
      jsKit.showNotificationsPanel(document.querySelector('[data-js-reset-password-success]').dataset.jsResetPasswordSuccess, 'success');
    },

    inputPattern: (e) => {
      const pattern = e.target.dataset.jsPattern;
      if (defaults.debugMode) {
        console.log(`inputPattern(${pattern})`);
      }
      const regex = new RegExp(`^[${pattern}]*$`);
      const forbiddenCharsRegex = new RegExp(`[^${pattern}]`, 'g');

      if (!regex.test(e.target.value)) {
        e.target.value = e.target.value.replace(forbiddenCharsRegex, '');
      }
    },

  };
})();

export default kitman;
